import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/landing/software-development/stockship_banner.webp";

function Stockship() {
  return (
    <section
      className="mobiuscase stockship_case p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="mob_icon">
              <StaticImage
                src="../../../images/landing/software-development/stock-logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={319}
                height={121}
              />
            </div>
            <p>
              Stock n Ship is a platform designed for businesses to manage their
              inventory, orders, product supplies, and customer refunds in a
              better-redefined manner through portals.
            </p>
            <Link
              to="/case-studies/stock-ship"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              View Case Study
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mt-4 mt-md-0"
          >
            <StaticImage
              src="../../../images/landing/software-development/stockship-desk.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={913}
              height={489}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Stockship;
